import { API, handleApiError } from "./utils";

export const getUser = async (id) => {
  try {
    const { data } = await API.get(`/users/${id}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};


export const userAdd = async (user) => {
  try {
    const { data } = await API.post("/users/", {
      site_id: user.Site_ID,
      first_name: user.First_name,
      last_name: user.Last_name,
      email: user.Email,
      password: user.Password,
      phone: user.Phone,
      role: user.Role,
      position: user.Position,
      notifications: user.Notifications ? 1 : 0,
      sms_notifications: user.SMS_Notifications ? 1 : 0,
      email_notifications: user.Email_Notifications ? 1 : 0,
      slack_notifications: user.Slack_Notifications ? 1 : 0,
      telegram_notifications: user.Telegram_Notifications ? 1 : 0,
      telegram_chat_id: user.Telegram_chat_id || null,
    });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const userUpdate = async (user) => {
  try {
    if (user.Notifications === 0) {
      user.SMS_Notifications = 0
      user.Email_Notifications = 0
      user.Slack_Notifications = 0
      user.Telegram_Notifications = 0
    }
    const { data } = await API.put(`/users/${user.user_ID}`, null, {
      params: {
        site_id: user.Site_ID,
        first_name: user.First_name,
        last_name: user.Last_name,
        email: user.Email,
        password: user.Password,
        phone: user.Phone,
        role: user.Role,
        position: user.Position,
        notifications: user.Notifications,
        sms_notifications: user.SMS_Notifications,
        email_notifications: user.Email_Notifications,
        slack_notifications: user.Slack_Notifications,
        telegram_notifications: user.Telegram_Notifications,
        telegram_chat_id: user.Telegram_chat_id || "",
        language: user.Language,
      }
    });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
export const userDelete = async (user, options = {}) => {
  try {
    const { data } = await API.delete(`/users/${user}`, {
      skipSuccessToast: options.skipSuccessToast || false,
    });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const profileUpdate = async (user) => {
  try {
    if (user.Notifications === 0) {
      user.SMS_Notifications = 0
      user.Email_Notifications = 0
      user.Slack_Notifications = 0
      user.Telegram_Notifications = 0
    }

    const params = {
      site_id: user.Site_ID,
      first_name: user.First_name,
      last_name: user.Last_name,
      email: user.Email,
      phone: user.Phone,
      role: user.Role,
      position: user.Position,
      notifications: user.Notifications,
      sms_notifications: user.SMS_Notifications,
      email_notifications: user.Email_Notifications,
      slack_notifications: user.Slack_Notifications,
      telegram_notifications: user.Telegram_Notifications,
      telegram_chat_id: user.Telegram_chat_id || "",
      language: user.Language,
    };

    const { data } = await API.put(`/users/`, null, { params });
      
    return { error: null, data };
  } catch (error) {
    console.error("profileUpdate error:", error.response?.data || error.message);
    return handleApiError(error);
  }
};

export const ChangePassword = async (user) => {
  try {
    const { data } = await API.put(`/users/changePassword/`, {
      OPassword: user.OPassword,
      NPassword: user.NPassword,
    });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
export const logIN = async (email, password) => {
  try {
    const { data } = await API.post("/users/login",
      {
        "Email": email,
        "Password": password
      }
    );
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getUsers = async (search, sortOrder, sortedColumn, page, per_page, order_by, companies, sites, roles,) => {
  try {
    const { data } = await API.get("/get_users", {
      params: {
        search,
        companies,
        sortOrder,
        sortedColumn,
        sites,
        roles,
        page,
        per_page,
        order_by

      }
    });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
